import React, { useEffect, useState } from 'react';
import {
  Box, Typography, TextField, Button, Grid, Card, CardMedia, CardContent, CardActions, CircularProgress
} from '@mui/material';
import { getAllTeams, getMyTeams, joinTeam } from '../api';
import GroupIcon from '@mui/icons-material/Group';

function TeamCard({ team, onJoin, joining }) {
  return (
    <Card sx={{ maxWidth: 320, minWidth: 260, m: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
      {team.image_url ? (
        <CardMedia component="img" height="140" image={team.image_url} alt={team.name} />
      ) : (
        <Box sx={{ height: 140, display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#f5f5f5' }}>
          <GroupIcon sx={{ fontSize: 60, color: '#bbb' }} />
        </Box>
      )}
      <CardContent>
        <Typography variant="h6" noWrap>{team.name}</Typography>
        {team.description && <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>{team.description}</Typography>}
      </CardContent>
      <CardActions sx={{ justifyContent: 'center', pb: 2 }}>
        <Button variant="contained" onClick={() => onJoin(team.id)} fullWidth disabled={joining}>
          {joining ? <CircularProgress size={22} color="inherit" /> : 'Join Team'}
        </Button>
      </CardActions>
    </Card>
  );
}

export default function CoachTeamsSearchSection() {
  const [search, setSearch] = useState('');
  const [searchValue, setSearchValue] = useState('');
  const [myTeams, setMyTeams] = useState([]);
  const [allTeams, setAllTeams] = useState([]);
  const [loading, setLoading] = useState(true);
  const [joining, setJoining] = useState({});

  const fetchTeams = async (searchTerm = '') => {
    setLoading(true);
    const [my, all] = await Promise.all([
      getMyTeams(),
      getAllTeams(searchTerm)
    ]);
    setMyTeams(my);
    setAllTeams(all);
    setLoading(false);
  };

  useEffect(() => { fetchTeams(); }, []);

  const handleSearch = e => {
    e.preventDefault();
    setSearch(searchValue);
    fetchTeams(searchValue);
  };

  const handleJoin = async (teamId) => {
    setJoining(j => ({ ...j, [teamId]: true }));
    try {
      await joinTeam(teamId);
      fetchTeams(search);
    } finally {
      setJoining(j => ({ ...j, [teamId]: false }));
    }
  };

  // Teams the user is not a member of
  const myTeamIds = new Set(myTeams.map(t => t.id));
  const suggestedTeams = allTeams.filter(t => !myTeamIds.has(t.id));

  return (
    <Box sx={{ maxWidth: 900, mx: 'auto', mt: 4 }}>
      <form onSubmit={handleSearch} style={{ display: 'flex', justifyContent: 'center', marginBottom: 32 }}>
        <TextField
          label="Search Teams"
          value={searchValue}
          onChange={e => setSearchValue(e.target.value)}
          variant="outlined"
          sx={{ width: 400, mr: 2 }}
        />
        <Button type="submit" variant="contained">Search</Button>
      </form>
      <Typography variant="h5" sx={{ mb: 2 }}>Search Teams</Typography>
      {loading ? <CircularProgress /> : (
        <Grid container spacing={2}>
          {suggestedTeams.length === 0 ? (
            <Typography sx={{ ml: 2 }}>No teams found.</Typography>
          ) : suggestedTeams.map(team => (
            <Grid item key={team.id}>
              <TeamCard team={team} onJoin={handleJoin} joining={joining[team.id]} />
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
} 